const Config = {
  steelCompassRoot: {
    production: 'https://api-3.coursio.com/api/',
    test: 'https://t-api.s.coursio.com/api/',
    local: 'http://localhost:80/api/'
  }
};

export default Config;
